<div class="team-project-selector-wrapper" (click)="toggleDropdown()" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <div class="team-project" *ngIf="teamProjectService.teamProject$ | async as teamProject">
    <div class="logo" [ngStyle]="{ 'background-image': 'url(' + getLogo(teamProject.LogoUrl) + ')' }"></div>
    <div class="team-project-info">
      <p class="team-name main" *ngIf="teamProject.TeamSlug">{{ teamProject.TeamName }}</p>
      <p class="company-name" [ngClass]="{ 'main': !teamProject.TeamSlug }">{{ teamProject.CompanyName }}</p>
    </div>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  cdkConnectedOverlayHasBackdrop="true"
  cdkConnectedOverlayBackdropClass="transparent-overlay"
  cdkConnectedOverlayPanelClass="overlay-team-project-dropdown"
  [cdkConnectedOverlayOffsetX]="overlayPosition.x"
  [cdkConnectedOverlayOffsetY]="overlayPosition.y"
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isDropdownOpen"
  (backdropClick)="toggleDropdown()"
>
  <div class="team-project-dropdown-wrapper">

    <div class="title-wrapper">
      <h4>{{ 'sidebar.teamProject.title' | translate }}</h4>
      <mat-icon (click)="toggleDropdown()">close</mat-icon>
    </div>

    <div class="search">
      <mat-form-field class="search-control" appearance="outline">
        <mat-icon matPrefix>search</mat-icon>
        <input [formControl]="searchControl" placeholder="{{ 'system.search' | translate }}" matInput>
      </mat-form-field>
    </div>

    <div class="team-projects">

      <div class="companies" *ngIf="isCompanies">
        <div class="team-project" *ngFor="let company of filteredCompanies" (click)="selectTeamProject(company)">
          <div class="logo" [ngStyle]="{ 'background-image': 'url(' + company.LogoUrl + ')' }"></div>
          <div class="team-project-info">
            <p class="company-name main"> {{ company.CompanyName }}</p>
          </div>
        </div>
      </div>

      <div class="teams" *ngIf="isTeams">
        <p class="title">{{ 'sidebar.teamProject.teams' | translate }}</p>

        <div class="team-project" *ngFor="let team of filteredTeams" (click)="selectTeamProject(team)">
          <div class="logo" [ngStyle]="{ 'background-image': 'url(' + team.LogoUrl + ')' }"></div>
          <div class="team-project-info">
            <p class="team-name main">{{ team.TeamName }}</p>
            <p class="company-name">{{ team.CompanyName }}</p>
          </div>
        </div>
      </div>

      <div class="search-empty" *ngIf="isSearchProjectsEmpty">
        <p>{{ 'sidebar.teamProject.noProjects' | translate }}</p>
      </div>

    </div>
  </div>
</ng-template>
